"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var DROPDOWN_BORDER_SIZE = 2,
    _default = function _default(a) {
  var b = a.disabled,
      c = a.menuWidth;
  return {
    dummyInput: function dummyInput(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        height: 0
      });
    },
    singleValue: function singleValue(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        fontSize: 12
      });
    },
    multiValue: function multiValue(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        alignItems: "center",
        backgroundColor: _vars.COLOURS.cyan.jungleGreen.monkey,
        color: "red",
        borderRadius: "3px",
        display: "inline-flex",
        justifyContent: "center",
        height: "25px",
        padding: "1px 8px 0 8px",
        textTransform: "uppercase"
      });
    },
    multiValueLabel: function multiValueLabel(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        color: _vars.COLOURS.grey.athens.parthenon,
        textTransform: "none",
        paddingLeft: 0,
        fontSize: _vars.FONT_SIZES.small,
        lineHeight: "24px"
      });
    },
    multiValueRemove: function multiValueRemove(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        backgroundColor: _vars.COLOURS.cyan.jungleGreen.monkey,
        color: _vars.COLOURS.grey.athens.parthenon,
        padding: 0,
        margin: "auto",
        ":hover": {
          backgroundColor: _vars.COLOURS.cyan.turquoise,
          color: _vars.COLOURS.grey.athens.parthenon
        },
        "& > svg": {
          width: "18px",
          height: "18px"
        }
      });
    },
    indicatorSeparator: function indicatorSeparator(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        display: "none"
      });
    },
    indicatorsContainer: function indicatorsContainer(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        minHeight: 38,
        padding: "0px 16px"
      });
    },
    control: function control(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        background: b ? _vars.COLOURS.grey.athens.parthenon : "transparent",
        boxShadow: "none",
        borderColor: _vars.COLOURS.grey.regent50,
        minHeight: 40,
        "&:hover": {
          borderColor: _vars.COLOURS.grey.regent50,
          background: _vars.COLOURS.grey.athens.parthenon
        },
        cursor: "pointer",
        border: "none",
        borderRadius: 4
      });
    },
    menu: function menu(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        boxShadow: "0 6px 20px 0 rgba(13, 51, 32, 0.1)",
        borderRadius: 8
      }, c ? {
        width: c,
        minWidth: c
      } : {});
    },
    menuList: function menuList(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        paddingTop: "5px",
        paddingBottom: "5px"
      });
    },
    menuPortal: function menuPortal(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        zIndex: 102
      });
    },
    placeholder: function placeholder(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        margin: 0,
        color: b ? _vars.COLOURS.grey.nevada : _vars.COLOURS.grey.nightRider,
        fontSize: _vars.FONT_SIZES["default"],
        fontWeight: _vars.FONT_WEIGHTS.medium,
        lineHeight: "22px",
        letterSpacing: "0.3px"
      });
    },
    option: function option(a, b) {
      var c = b.isSelected;
      return _objectSpread(_objectSpread({}, a), {}, {
        backgroundColor: "transparent",
        cursor: "pointer",
        padding: "16px 12px",
        fontWeight: c ? "bold" : "initial",
        color: _vars.COLOURS.mono.black,
        "&:hover": {
          backgroundColor: _vars.COLOURS.grey.catSkillWhite
        }
      });
    },
    valueContainer: function valueContainer(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        overflow: "visible",
        " > input": {
          height: 0
        },
        paddingTop: 0,
        paddingBottom: 0
      });
    },
    input: function input(a) {
      return _objectSpread(_objectSpread({}, a), {}, {
        position: "absolute",
        margin: "auto",
        width: "100%",
        " > div": {
          width: "100%",
          " > input": {
            maxWidth: "calc(100% - 20px)"
          }
        }
      });
    }
  };
};

exports["default"] = _default;